import React, { Component } from 'react';
import Form, {
    FormComponentProps
} from 'antd/lib/form';
import { Row } from 'antd'
// import Row from "antd/lib/row";
import AntWfComponent from "./AntWfComponent";
import { uimap, FieldBase } from "easyui-core";
import './AntWfForm.css';
// import "antd/dist/antd.css";
import { AntInput } from "../form/textfields/Ant-input";
import { AntTextarea } from "../form/textfields/Ant-textarea";
import { AntDatetimePick } from "../form/datetimepick/Ant-datetime";
import { AntTableForm } from "../table/anttable/Ant-table";
import { AntEditTableForm } from "../table/anttable/Ant-table-edit";

interface AntWfFormProps extends FormComponentProps {
    onSubmit?: (e) => {} | void,
    form: any,
    fields: FieldBase<any>[],
    formLayout?: string
}

class AntWfForm extends Component<
    {
        onSubmit: (e) => {},
        form: any,
        fields: FieldBase<any>[]
    }, {
        formLayout: "horizontal" | "inline" | "vertical"
    }> {

    uimap: any
    constructor(props) {
        super(props);

        this.uimap = uimap

        this.state = {
            formLayout: "vertical"
        }

        const formItems = [
            AntInput,
            AntTextarea,
            AntDatetimePick,
            AntTableForm,
            AntEditTableForm
        ]
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    }
    render() {
        const formItems = this.props.fields.map((field, index) => (
            <AntWfComponent component={this.uimap.get(field.selector)} key={field.key}
                form={this.props.form} field={field} formLayout={this.state.formLayout}></AntWfComponent>
        ));
        return (
            <Form onSubmit={this.handleSubmit} layout={this.state.formLayout} className="login-form">
                <Row gutter={16}>
                    {formItems}
                </Row>
            </Form>
        )
    }
}
export const WrappedAntWfForm = Form.create<AntWfFormProps>({ name: 'antWfForm' })(AntWfForm);